import styled from 'styled-components'

const H5 = styled.h5``

export default H5
